import { Button, Link, Stack, TextField, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'

const SECRET_CODE_LENGTH = 6

const EnterSecurityCode = ({ onConfirm, useBackupCodes, alert }) => {
  const codeInputRefs = useRef([])
  const [canVerify, setCanVerify] = useState(false)

  const handleKeyDown = (e, i) => {
    setCanVerify(shouldEnableVerify())
    if (e.key === 'Backspace') {
      e.preventDefault()
      const isLast =
        i === SECRET_CODE_LENGTH - 1 &&
        codeInputRefs.current[SECRET_CODE_LENGTH - 1].value
      codeInputRefs.current[isLast || i === 0 ? i : i - 1].value = null
      if (i > 0) codeInputRefs.current[isLast || i === 0 ? i : i - 1].focus()
    } else if (e.key === 'Enter' && canVerify) handleCodeSubmit()
  }

  const shouldEnableVerify = () => {
    return !codeInputRefs.current.find(
      (ref) => !ref.value || ref.value === null,
    )
  }

  const onCodeInput = (input) => {
    if (input.length > 1) return
    const index =
      document.activeElement.id[document.activeElement.id.length - 1]
    if (index < SECRET_CODE_LENGTH - 1) {
      document.activeElement.blur()
      codeInputRefs.current[Number(index) + 1].focus()
    } else {
      document.getElementById('verify-button').focus()
    }
    setCanVerify(shouldEnableVerify())
  }

  const onPaste = (e) => {
    if (!e.target.id.includes('securityCodeField')) return
    e.stopPropagation()
    e.preventDefault()
    const clipBoardText = e.clipboardData || window.clipboardData
    const code = clipBoardText.getData('Text')
    codeInputRefs.current.map((ref, i) => {
      return (ref.value = code[i])
    })
    setCanVerify(shouldEnableVerify())
  }

  const handleCodeSubmit = () => {
    let code = ''
    codeInputRefs.current.map((ref, i) => {
      return (code = code + ref.value)
    })
    onConfirm(code)
  }

  useEffect(() => {
    codeInputRefs.current[0].focus()
    addEventListener('paste', onPaste)
    return () => {
      document.removeEventListener('paste', onPaste)
    }
  }, [])

  useEffect(() => {
    if (alert != null) {
      codeInputRefs.current.map((ref) => {
        return (ref.value = null)
      })
      codeInputRefs.current[0].focus()
    }
  }, [alert])

  return (
    <Stack
      sx={{
        gap: 4,
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Stack sx={{ flexDirection: 'row', gap: 2 }}>
        {[...Array(SECRET_CODE_LENGTH)].map((_, i) => {
          return (
            <TextField
              sx={{
                width: { xs: '35px', md: '50px' },
                input: {
                  fontSize: { xs: '16px', md: '32px' },
                  px: 0,
                  py: 1,
                  textAlign: 'center',
                  textTransform: 'uppercase',
                },
              }}
              slotProps={{ input: { inputProps: { maxLength: 1 } } }}
              id={'securityCodeField-' + i}
              key={i}
              inputRef={(el) => (codeInputRefs.current[i] = el)}
              onChange={onCodeInput}
              onKeyDown={(e) => handleKeyDown(e, i)}
            ></TextField>
          )
        })}
      </Stack>
      {useBackupCodes && (
        <Typography variant="body2" color="text.secondary">
          I do not have access to my authenticator app.{' '}
          <Link variant="body2" onClick={() => useBackupCodes()}>
            Use backup code instead.
          </Link>
        </Typography>
      )}
      <Button
        id="verify-button"
        variant="contained"
        color="primary"
        disabled={!canVerify}
        onClick={() => handleCodeSubmit()}
      >
        Verify
      </Button>
    </Stack>
  )
}

export default EnterSecurityCode
